module.exports = __webpack_public_path__ + "img/20200428145917TIM截图20200428144829.ecd21d6d.png";